import styled from "styled-components";

export const StyledForm = styled.form``;

export const StyledWrapper = styled.div`
  .cashout-actions {
    button {
      padding: 8px 12px 8px 16px;
      height: 40px;
      color: ${({ theme }) => theme.colors.neutralsWhite};
      ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}
      background-color: ${({ theme }) => theme.colors.primaryBackground};
      border: 0;
      border-radius: 20px;
      display: flex;
      gap: 6px;
      align-items: center;
      cursor: pointer;
    }

    & > div > div:not(:first-child) {
      padding: 16px 12px 8px;
      min-width: 13rem;

      li {
        padding: 10px 12px;
        color: ${({ theme }) => theme.colors.primaryBackgroundHover};
        ${({ theme }) => theme.fontStyles.InterfaceCopy}
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }

  .cashout-amount {
    margin-top: 40px;
    ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    text-align: right;
  }

  .cashout-card {
    padding: 32px 32px 16px 32px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.CommentsBody}
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint30};
    border: 1px solid ${({ theme }) => theme.colors.primaryRulerTint15};
    border-radius: 4px;
    display: flex;
    gap: 32px;
    justify-content: space-between;
  }

  .cashout-form {
    margin: 40px 0 4px;
    width: 100%;
    display: flex;
    gap: 24px;
  }

  .cashout-input {
    width: 300px;
  }

  .cashout-timestamp {
    white-space: nowrap;
  }

  .cashout-transactions {
    padding-top: 16px;
    min-width: 32rem;
  }

  .cashout-transaction-links {
    display: flex;
    gap: 16px;

    a {
      cursor: pointer;
    }

    span {
      color: ${({ theme }) => theme.colors.primaryText};
      ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopyBold}
    }

    .declined {
      color: ${({ theme }) => theme.colors.offTrackText};
    }
  }

  .cashout-type {
    margin-top: 4px;
    ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopySmall}
  }

  .cashout-user {
    color: ${({ theme }) => theme.colors.neutralsText};
    display: flex;
    gap: 8px;

    a {
      color: ${({ theme }) => theme.colors.primaryText};
      ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}
      line-height: 20px;
    }
  }
`;
